// Module
var code = "<p> <label>Instances Count</label> <input type=\"range\" min=\"1\" max=\"10000\" step=\"10\" oninput=\"scatter.p.pointsCount.set(event.target.value)\"> </p> ";
// Exports
export default code;